
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/support/[status]",
      function () {
        return require("private-next-pages/[locale]/support/[status]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/support/[status]"])
      });
    }
  